import { Form, FormItem } from '@/components';
import styled from 'styled-components';
import { COLORS, DEVICES, pickThemeFontStyles } from '@/theme';

export const StyledForm = styled(Form)`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 1.5rem;
  width: 100%;

  @media screen and ${DEVICES.LAPTOP_S} {
    grid-template-columns: minmax(0, 3fr) minmax(0, 2fr);
  }
`;

export const StyledSettingsCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1.75rem;
  background-color: ${COLORS.WHITE};
  border: 1px solid ${COLORS.COLOR_BORDER_SECONDARY};
  border-radius: 0.75rem;
  box-shadow: 0 0.0625rem 0.125rem rgba(16, 24, 40, 0.06);
`;

export const StyledSettingsTitle = styled.h2`
  ${pickThemeFontStyles('18', '24', 'BOLD')};
  color: ${COLORS.TEXT_PRIMARY};
  margin: 0 0 1.25rem;
`;

export const StyledFormItem = styled(FormItem)`
  width: 100%;
  max-width: 26rem;
  margin-bottom: 1.25rem;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const StyledPreviewColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const StyledPreviewTitle = styled.div`
  ${pickThemeFontStyles('14', '20', 'BOLD')};
  color: ${COLORS.TEXT_PRIMARY};
`;
